// extracted by mini-css-extract-plugin
export default {"modalOverlay":"pD-z","modalContent":"qD-z","header":"rD-z","close":"sD-z"};